import { Injectable } from '@angular/core';
import { FieldAgentClient, WebTrackUser, WebServiceCallResult, ProductPrice, Computer, OrderType, Product, QuantityFromTallyRequest, QuantityFromTallyResponse, Product2 } from 'ep-bt-field-agent-proxy';
import { BistrackConfig, PerDefaults } from 'ep-bt-controls';
import { EpbtFaQuickTransferModel } from '../models/epbt-fa-quick-transfer-model';
import { EpbtFaQuickTransferLineModel } from '../models/epbt-fa-quick-transfer-line-model';
import { EpbtFieldAgentService } from '../services/epbt-field-agent.service';
import { EpbtFaTallyModel } from '../models/epbt-fa-tally.model'
import { Router } from '@angular/router';



@Injectable({
  providedIn: 'root'
})
export class EpbtFaQuickTransferService {

  //This will be used when selected from binlocation grid and used for update of bins
  // public selectedQuickTransfer: any;

  //List of products used for quick transfer
  // public selectedProducts: any[] = [];

  // //page name
  // public fromPage: string;
  fromDashbard: boolean;

  public wizardStep: number = 0;

  //Validation flag quick transfer form
  public quickTransferFormFlag: boolean = false;

  //Selected source branchid from quick transfer
  public selectedSourceBranchId: number;

  //Selected destination branchid from quick transfer
  public selectedDestinationBranchId: number;

  //Selected source branch from quick transfer
  public selectedSourceBranch: any;

  //Selected destination branch from quick transfer
  public selectedDestinationBranch: any;

  // public selectedProductsForBinding: any[] = [];

  public isNegotiationEdit = false;

  //public isSummary = false;

  successMessage: string = "";

  public quickTransfer: EpbtFaQuickTransferModel = new EpbtFaQuickTransferModel();

  isProductValid(product: any) {
    //need to implement 


  }

  public bisTrackSettings: any;
  public webTrackUser: WebTrackUser;

  constructor(private client: FieldAgentClient, private config: BistrackConfig,
    private faService: EpbtFieldAgentService, private router: Router, ) {
    this.faService.getBisTrackSetting((bisTrackSettings: any) => {
      this.bisTrackSettings = bisTrackSettings;
    });
    this.faService.getWebTrackUser((webTrackUser: any) => {
      this.webTrackUser = webTrackUser;
    });
  }

  createTransferLine(productObj: Product2) {
    let product: Product2 = new Product2();
    product = productObj;
    product.inputPers = [];
    let transferLine = new EpbtFaQuickTransferLineModel(product);
    // transferLine.inputPer = product.inputPer;
    // transferLine.branchId = this.quickTransfer.sourceBranch.branchID;
    transferLine.quantity = 0;
    this.quickTransfer.lineAdd(transferLine)

    transferLine.quantity = 0;
    transferLine.isSave = true;
    // transferLine.selectedPer = this.selectedPer;
    // if (transferLine.product.inputPers && transferLine.product.inputPers.length == 0) {
    transferLine.product.dateTimeCreated = new Date();
    transferLine.product.dateTimeLastModified = new Date();
    this.loadProductsPers(transferLine.product, (outProduct: Product2) => {
      transferLine.product = outProduct ? outProduct : transferLine.product;
      // for tallied product

      if (transferLine.checkTallyProduct(transferLine.product.tallyLengths) && transferLine.tallyCustom != null) {
        transferLine.tallyCustom = new EpbtFaTallyModel();

        transferLine.tallyEntryLines.forEach(element => {
          element.Quantity = element.Quantity ? element.Quantity : 0;
          transferLine.tallyCustom.add(element.Quantity.toString(), element.Length.toString());
        });

        transferLine.quantity = transferLine.tallyCustom.totalTallyLength;
        transferLine.quantityTally = transferLine.tallyCustom.tallyString;

        this.updateLineTotals(transferLine);
        // Set to product inputPer 
        // transferLine.inputPer = transferLine.product.inputPer;
        // transferLine.inputPerCode = transferLine.inputPer.perCode;
        // transferLine.inputPerID = transferLine.inputPer.perId;
        // transferLine.per = transferLine.inputPer;
        transferLine.perID = transferLine.product.inputPer.perId;

      }
      else {
        transferLine.perID = transferLine.inputPerID && transferLine.inputPerID != 0 ? transferLine.inputPerID : transferLine.product.inputPer.perId;
      }
    });
  }

  //Moved from product list component 
  createQuickTransferProduct(selectedProduct) {
    let product: Product2 = new Product2();
    product = selectedProduct;
    product.inputPers = [];
    let transferLine = new EpbtFaQuickTransferLineModel(product);
    transferLine.inputPer = product.inputPer;
    transferLine.branchId = this.quickTransfer.sourceBranch.branchID;
    transferLine.quantity = 0;
    this.quickTransfer.lineAdd(transferLine)
  }

  addQuickTransferXmlPost(quickTransferXml: string,
    subscribe: (result: WebServiceCallResult) => void) {

    this.client.sendQuickTransfer(quickTransferXml).subscribe(res => {
      subscribe(res);
    });
  }

  getComputer(computerID: number,
    subscribe: (result: Computer) => void) {

    this.client.getComputer(computerID).subscribe(res => {
      subscribe(res);
    });
  }

  calculateCosts(selectedTransferLine: EpbtFaQuickTransferLineModel, subscribe: (prices: ProductPrice) => void) {

    let priceParams = selectedTransferLine.GetProductPriceParameters();
    this.client.getProductPriceEx(priceParams).subscribe(prices => {
      subscribe(prices);
    });
  }

  getReservedDocumentID(subscribe: (orderId: number) => void) {
    this.client.getReservedDocumentID("OrderHeader", "OrderID").subscribe(orderId => {
      subscribe(orderId);
    });
  }

  getReservedOrderNumber(subscribe: (orderNumber: string) => void) {
    this.client.getReservedOrderNumber(OrderType.Transfer).subscribe(orderNumber => {
      subscribe(orderNumber);
    });
  }

  getPerConversion(fromPerID: number, toPerID: number, productId: number, imperial: boolean, thickness: number, width: number, length: number, weight: number,
    subscribe: (perConversion: number) => void) {
    var perConversion: number;
    this.client.getPerConversion(fromPerID, toPerID, productId, imperial, thickness, width, length, weight).subscribe(res => {
      if (res != null) {
        perConversion = res;
      }
      subscribe(perConversion);
    });
  }

  updateLineTotals(selectedQuickTransferLine: EpbtFaQuickTransferLineModel) {
    let perConvInchToMillimetre = 0;
    let perConvMillimetreToInch = 0;
    let perConvFootToMetre = 0;
    let perCubicMetreToBoardFoot = 0;

    this.getPerConversion(PerDefaults.Inch, PerDefaults.Millimetre, 0, false, 0, 0, 0, 0, (perConversion1: number) => {
      perConvInchToMillimetre = perConversion1;
      console.log(perConvInchToMillimetre, "perConvInchToMillimetre");

      this.getPerConversion(PerDefaults.Millimetre, PerDefaults.Inch, 0, false, 0, 0, 0, 0, (perConversion2: number) => {
        perConvMillimetreToInch = perConversion2;

        this.getPerConversion(PerDefaults.Foot, PerDefaults.Metre, 0, false, 0, 0, 0, 0, (perConversion3: number) => {
          perConvFootToMetre = perConversion3;

          this.getPerConversion(PerDefaults.CubicMetre, PerDefaults.BoardFoot, 0, false, 0, 0, 0, 0, (perConversion4: number) => {
            perCubicMetreToBoardFoot = perConversion4;

            selectedQuickTransferLine.tallyCustom.getTotalsFromTally(selectedQuickTransferLine.product.thickness,
              selectedQuickTransferLine.product.width, selectedQuickTransferLine.product.imperial, perConvInchToMillimetre, perConvMillimetreToInch,
              perConvFootToMetre, perCubicMetreToBoardFoot)

            selectedQuickTransferLine.totalTallyLength = selectedQuickTransferLine.tallyCustom.totalTallyLength2;
            selectedQuickTransferLine.totalTallyArea = selectedQuickTransferLine.tallyCustom.totalTallyArea;
            selectedQuickTransferLine.totalTallyVolume = selectedQuickTransferLine.tallyCustom.totalTallyVolume;

            this.calculateCosts(selectedQuickTransferLine, (prices: ProductPrice) => {
              selectedQuickTransferLine.unitCostPrice = prices.unitCostPrice;
              selectedQuickTransferLine.totalCost = prices.totalCostPrice;

              // setTimeout(() => {
              if (!selectedQuickTransferLine.product.inputPers || selectedQuickTransferLine.product.inputPers.length == 0) {
                selectedQuickTransferLine.product.dateTimeCreated = new Date();
                selectedQuickTransferLine.product.dateTimeLastModified = new Date();
                this.loadProductsPers(selectedQuickTransferLine.product, (outProduct: Product2) => {
                  selectedQuickTransferLine.product = outProduct ? outProduct : selectedQuickTransferLine.product;
                  this.updateQuickTransferLineData(selectedQuickTransferLine);
                });
              }
              else {
                this.updateQuickTransferLineData(selectedQuickTransferLine);
              }
              // }, 100);
            });

          });
        });
      });
    });

  }

  private updateQuickTransferLineData(transferLine: EpbtFaQuickTransferLineModel) {

    let talliesReq: QuantityFromTallyRequest[] = [];
    let tallyreq: QuantityFromTallyRequest = new QuantityFromTallyRequest();
    tallyreq.lineNumber = transferLine.lineNumber;
    tallyreq.productID = transferLine.product.productId;
    tallyreq.quantityTally = transferLine.quantityTally;
    tallyreq.quantityPerID = transferLine.product.inputPer.perId;
    tallyreq.thickness = transferLine.product.thickness;
    tallyreq.width = transferLine.product.width;
    tallyreq.precision = 4;
    talliesReq.push(tallyreq);
    console.log(talliesReq, "talliesReq");
    this.getQuantitiesFromTallies(talliesReq, (talliesRes: QuantityFromTallyResponse[]) => {
      console.log(talliesRes, "talliesRes");

      if (!transferLine.tallyCustom) {
        transferLine.tallyCustom = new EpbtFaTallyModel();
      }
      else {
        // Initialize line Input per values
        // we do not allow change input per fro tallied products, initialize 
        // line input per valuesfrom Product
        transferLine.inputPer = transferLine.product.inputPer;
        transferLine.inputPerCode = transferLine.inputPer.perCode;
        transferLine.inputPerID = transferLine.inputPer.perId;
        // initialize line Per values
        transferLine.per = transferLine.inputPer;
        transferLine.perID = transferLine.per.perId;
        // calulate Tally qty
        let tallyRes = talliesRes && talliesRes.length > 0 ? talliesRes.find(tally => tally.lineNumber == transferLine.lineNumber && tally.productID == transferLine.product.productId) : null;
        if (tallyRes != null) { transferLine.quantity = tallyRes.quantity }
        else { transferLine.quantity = 0 }
      }
      // let index: number = this.quicktransferService.quickTransfer.quickTransferLines.findIndex(item => item.lineNumber == this.quicktransferService.quickTransfer.selectedLineIndex);
      // this.quicktransferService.quickTransfer.quickTransferLines[index] = transferLine;
      // this.router.navigate(['/home/quicktransfer']);
    });
  }

  loadAllProductsPers(productsList: Product2[], subscribe: (outProductsList: Product2[]) => void) {
    this.client.loadProductPersList(productsList).subscribe(outProductsList => {
      subscribe(outProductsList);
    });
  }

  loadProductsPers(product: Product2, subscribe: (outProduct: Product2) => void) {
    this.client.loadProductPers(product).subscribe(outProduct => {
      subscribe(outProduct);
    });
  }

  getQuantitiesFromTallies(tallies: QuantityFromTallyRequest[], subscribe: (talliesRes: QuantityFromTallyResponse[]) => void) {
    this.client.getQuantitiesFromTallies(tallies).subscribe(talliesRes => {
      subscribe(talliesRes);
    });
  }

  checkIsVMI(productId: number, branchId: number, subscribe: (result: boolean) => void) {
    this.client.isVMI(productId, branchId).subscribe(result => {
      subscribe(result);
    });
  }

  getProductBranchVMIRuleID(productId: number, branchId: number, subscribe: (result: number) => void) {
    this.client.getProductBranchVMIRuleID(productId, branchId, new Date()).subscribe(result => {
      subscribe(result);
    });
  }

  clearQuickTransferData() {
    this.quickTransferFormFlag = false;
    this.selectedSourceBranchId = null;
    this.selectedDestinationBranchId = null;
    this.selectedSourceBranch = null;
    this.selectedDestinationBranch = null;
    this.isNegotiationEdit = false;
    this.wizardStep = 0;
    this.successMessage = "";
    this.fromDashbard = false;
    this.quickTransfer = new EpbtFaQuickTransferModel();  //need to change
    //this.quickTransfer.
  }
}
